module.exports = __webpack_public_path__ + "img/akm21cm.bd185b38.jpg";